const EsPrizes = () => {
  return (
    <>
      <section>
        <p>
          Consulte la información de «Cómo jugar» que se encuentra en el sitio
          web (
          <a
            href="https://es.nbafantasy.nba.com/help/rules"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://es.nbafantasy.nba.com/help/rules
          </a>
          ) para obtener todos los detalles sobre la acumulación de puntos.
        </p>
        <p>Habrá en total 30 ganadores del Concurso como sigue:</p>
        <p>Temporada completa</p>
        <p>
          Los premios se otorgarán a los cinco (5) Participantes con más puntos
          acumulados durante la temporada. A los efectos de evitar cualquier
          duda, habrá cinco (5) premios en total a ganar, NO cinco (5) premios
          para cada país.
        </p>
        <p>
          Se otorgará un (1) Premio por semana (veinticinco [25] en total) al
          Participante con más puntos en una semana determinada. A los efectos
          de evitar cualquier duda, habrá un (1) premio semanal total a ganar,
          NO un (1) premio semanal por cada país.
        </p>
        <p>
          En caso de empate entre Participantes para los premios de la temporada
          o para un premio semanal, se aplicará un sistema de desempate para
          determinar la persona ganadora. El criterio de desempate será el
          Participante que haya iniciado sesión y creado su equipo en primer
          lugar (en la fecha más temprana) según los datos recogidos por el
          Patrocinador.
        </p>
      </section>
      <section>
        <h3>Gran premio - Primer (1.er) puesto de la clasificación general</h3>
        <p>
          Habrá un (1) ganador del gran premio (en lo sucesivo, el «Ganador del
          Gran Premio») que se otorgará al Participante con más puntos
          acumulados durante la duración del Concurso.
        </p>
        <p>El «Gran Premio» consiste en:</p>
        <ul>
          <li>
            <p>
              Transporte desde la residencia del Ganador a París (Francia), ya
              sea mediante dos (2) billetes de avión de ida y vuelta en clase
              turista desde el aeropuerto internacional más cercano a la
              residencia del Ganador hasta un aeropuerto en París (Francia), o
              mediante billetes de tren de ida y vuelta desde la estación más
              cercana a la residencia del Ganador hasta París (Francia), según
              lo determine y comunique el Patrocinador a su entera discreción.
            </p>
            <ul>
              <li>
                <p>
                  La selección específica de asientos queda a discreción
                  exclusiva del Patrocinador.
                </p>
              </li>
              <li>
                <p>
                  El Patrocinador determinará, a su entera discreción, el método
                  de transporte, las fechas y los horarios exactos
                </p>
              </li>
            </ul>
          </li>
          <li>
            <p>
              Una (1) habitación de hotel para dos (2) personas en París por un
              total de tres (3) noches en un hotel de 3-4 estrellas
            </p>
            <ul>
              <li>
                <p>
                  El Patrocinador elegirá, a su entera discreción, los hoteles,
                  las habitaciones y las fechas
                </p>
              </li>
            </ul>
          </li>
          <li>
            <p>
              Dos (2) entradas para un (1) Partido de la NBA en París durante la
              temporada 2027-28 de la NBA (el «Partido»)
            </p>
            <ul>
              <li>
                <p>
                  La fecha exacta del Partido queda a entera discreción del
                  Patrocinador.
                </p>
              </li>
            </ul>
          </li>
          <li>
            <p>
              Un trofeo al Primer Puesto, entregado en persona o por mensajero
              en el domicilio del ganador, según decida el Patrocinador a su
              entera discreción.
            </p>
          </li>
        </ul>
        <p>
          El valor total acumulado aproximado del Gran Premio es de 2500,00
          euros.
        </p>
        <p>
          El Ganador puede designar a un (1) amigo/a o familiar para que le
          acompañe (en lo sucesivo, el «Invitado»).
        </p>
        <p>
          Los ganadores del Gran Premio de cualquier temporada anterior no
          podrán reclamar el Gran Premio. En tales circunstancias, el Gran
          Premio se otorgará al siguiente Participante que cumpla los
          requisitos, y el ganador del Gran Premio que no cumpla los requisitos
          reclamará en su lugar el premio del Segundo (2.º) puesto.
        </p>
      </section>
      <section>
        <p>
          Cuatro (4) premios secundarios adicionales de la temporada completa -
          Del segundo (2.º) al quinto (5.º) de la clasificación general Estos
          cuatro (4) premios secundarios adicionales se otorgarán a los
          Participantes con el segundo (2.º), tercer (3.º), cuarto (4.º) y
          quinto (5.º) número más elevado de puntos acumulados durante la
          duración del Concurso (en lo sucesivo e individualmente, un «Ganador
          de un Premio secundario»).
        </p>
        <ul>
          <li>
            <p>
              Segundo (2.º) premio: tarjeta regalo para la NBA Store de 200,00 €
              en{" "}
              <a
                href="https://nbastore.eu"
                target="_blank"
                rel="noopener noreferrer"
              >
                https://nbastore.eu
              </a>
            </p>
          </li>
          <li>
            <p>
              Tercer (3.º) premio: tarjeta regalo para la NBA Store de 200,00 €
              en{" "}
              <a
                href="https://nbastore.eu"
                target="_blank"
                rel="noopener noreferrer"
              >
                https://nbastore.eu
              </a>
            </p>
          </li>
          <li>
            <p>
              Cuarto (4.º) premio: tarjeta regalo para la NBA Store de 200,00 €
              en{" "}
              <a
                href="https://nbastore.eu"
                target="_blank"
                rel="noopener noreferrer"
              >
                https://nbastore.eu
              </a>
            </p>
          </li>
          <li>
            <p>
              Quinto (5.º) premio: tarjeta regalo para la NBA Store de 200,00 €
              en{" "}
              <a
                href="https://nbastore.eu"
                target="_blank"
                rel="noopener noreferrer"
              >
                https://nbastore.eu
              </a>
            </p>
          </li>
        </ul>
      </section>
      <section>
        <h3>Semanal:</h3>
        <p>
          Se concederán veinticinco (25) premios adicionales al Participante con
          más puntos en una semana determinada (en lo sucesivo e
          individualmente, un «Ganador de un Premio semanal»). Se concederá un
          (1) premio semanal por semana durante las 25 semanas de duración total
          del Concurso.
        </p>
        <p>
          El Premio Semanal consistirá en una copia digital de NBA 2K27 y una
          tarjeta regalo para la tienda de la NBA por valor de 100,00 € en{" "}
          <a
            href="https://nbastore.eu/"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://nbastore.eu/
          </a>{" "}
          (a determinar por el Patrocinador a su entera discreción). El valor
          total acumulado aproximado de un Premio semanal es de 150,00 euros.
        </p>
        <p>
          Para poder optar a ganar los Premios semanales, los usuarios deben
          haber participado en el juego antes del inicio de la temporada o un
          mínimo de 14 días antes del inicio del periodo de la semana de juego
          correspondiente.
        </p>
        <p>
          Encontrará una lista completa de las semanas de juego en la sección{" "}
          <a
            href="https://es.nbafantasy.nba.com/help/rules"
            target="_blank"
            rel="noopener noreferrer"
          >
            «Cómo jugar»
          </a>
          . Las semanas de juego están sujetas a cambios a única discreción del
          Patrocinador.
        </p>
      </section>
      <section>
        <h3>Requisitos:</h3>
        <p>
          La Promoción está limitada a los residentes de Alemania, Austria,
          Bélgica, Dinamarca, España, Finlandia, Francia, Grecia, Hungría,
          Irlanda, Noruega, Países Bajos, Portugal, Reino Unido, República
          Checa, Serbia, y Suiza (en lo sucesivo y conjuntamente, el
          «Territorio»), que tengan dieciocho (18) años de edad o más en la
          fecha de presentación de la inscripción al concurso (en lo sucesivo e
          individualmente, un «Participante»). A los efectos de evitar cualquier
          duda, los residentes fuera de las jurisdicciones antes mencionadas y/o
          los Participantes que no hayan cumplido los dieciocho (18) años de
          edad en la fecha de presentación de la participación en el concurso no
          podrán participar en la presente Promoción. El Patrocinador, tal y
          como se define a continuación, se reserva el derecho a confirmar la
          elegibilidad de cualquier Participante, incluida la constatación de su
          edad.
        </p>
      </section>
    </>
  );
};

export { EsPrizes };
